import { render, staticRenderFns } from "./ElementaryFormUserReport.vue?vue&type=template&id=1b9dd7be"
import script from "./ElementaryFormUserReport.vue?vue&type=script&lang=js"
export * from "./ElementaryFormUserReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9dd7be')) {
      api.createRecord('1b9dd7be', component.options)
    } else {
      api.reload('1b9dd7be', component.options)
    }
    module.hot.accept("./ElementaryFormUserReport.vue?vue&type=template&id=1b9dd7be", function () {
      api.rerender('1b9dd7be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/ElementaryFormUserReport.vue"
export default component.exports